/**
 * @package admin
 */

import ChangesetGenerator from './changeset-generator.data';
import Criteria from './criteria.data';
import Entity from './entity.data';
import EntityCollection from './entity-collection.data';
import EntityDefinition from './entity-definition.data';
import EntityFactory from './entity-factory.data';
import EntityHydrator from './entity-hydrator.data';
import Repository from './repository.data';
import ErrorResolver from './error-resolver.data';
import ErrorStore from './error-store.data';
import FilterFactory from './filter-factory.data';

// eslint-disable-next-line sw-deprecation-rules/private-feature-declarations
export default {
    ChangesetGenerator,
    Criteria,
    Entity,
    EntityCollection,
    EntityDefinition,
    EntityFactory,
    EntityHydrator,
    Repository,
    ErrorResolver,
    ErrorStore,
    FilterFactory,
};
